import { render } from "./ProductListCardComponent.vue?vue&type=template&id=6bc9218e&scoped=true"
import script from "./ProductListCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductListCardComponent.vue?vue&type=script&lang=js"

import "./ProductListCardComponent.vue?vue&type=style&index=0&id=6bc9218e&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc9218e"]])

export default __exports__